<template lang="pug">
el-dialog.modal-preencher-contrato-eudr(
    :visible='mostrarModal',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='true',
    @close='fecharModal',
    fullscreen
)
    .header(slot='title')
        h3 {{ $t('mensagens.rastreabilidadeEmpresa.modalPreencherEudr.titulo') }}
    .modal-preencher-contrato-eudr
        .modal-preencher-contrato-eudr__container
            .modal-preencher-contrato-eudr__info
                i.mdi.mdi-information
                p.modal-preencher-contrato-eudr__info-texto {{ $t('mensagens.rastreabilidadeEmpresa.modalPreencherEudr.info') }}
            .modal-preencher-contrato-eudr__aceite
                p {{ $t('mensagens.rastreabilidadeEmpresa.modalPreencherEudr.aceite') }}
                el-checkbox(:checked='aceite', v-model='aceite') {{ $t('mensagens.rastreabilidadeEmpresa.modalPreencherEudr.checkboxLabel') }}
    .footer(slot='footer')
        el-button(type='default', @click='fecharModal()') {{ $t('mensagens.rastreabilidadeEmpresa.modalPreencherEudr.voltar') }}
        el-button(type='primary', :disabled='!aceite', @click='continuar()') {{ $t('mensagens.rastreabilidadeEmpresa.modalPreencherEudr.continuar') }}
</template>

<script>
export default {
    name: 'ModalPreencherContratoEudr',
    props: {
        mostrarModal: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            aceite: false
        };
    },
    methods: {
        fecharModal() {
            this.$emit('cancelarPreenchimento');
        },
        continuar() {
            this.$emit('continuarPreenchimento');
        }
    }
};
</script>

<style lang="scss">
.el-dialog__wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-dialog.is-fullscreen {
    height: fit-content;
}

.modal-preencher-contrato-eudr {
    .el-dialog {
        max-width: 650px;

        .el-dialog__header {
            background: #f6f6f6 !important;
            padding-bottom: 0 !important;
        }

        .header {
            padding-bottom: 8px;
        }
    }

    .el-dialog__footer {
        border-top: 1px solid #e4e7ed;
    }

    .el-checkbox__label {
        font-size: 14px;
        font-weight: bold;
        padding-left: 6px;
    }

    .footer {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
    }

    .el-button + .el-button {
        margin-left: 0;
    }

    &__container {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    &__info {
        display: flex;
        align-items: center;
        gap: 8px;
        background-color: #fdf7e8;
        border: 1px solid #faeac6;
        border-radius: 16px;
        padding: 16px 8px;
        word-break: normal;

        i {
            color: #d89c1a;
            font-size: 24px;
        }

        p {
            font-size: 14px;
            word-break: normal;
            color: var(--text-secondary);
            margin: 0;
        }
    }

    &__aceite {
        display: flex;
        flex-direction: column;
        gap: 8px;
        word-break: normal;

        p {
            font-size: 14px;
            color: var(--text-secondary);
            margin: 0;
        }
    }

    .footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
}
</style>
